import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    organizationTree: {},
    allCarrierFeedback: [],
    allQualificationPlan: [],
    allQualificationMatrix: [],
    allSuccessStatistics: [],
    documents: {},
    loading: false,
    error: null,
};

const carrierFeedbackSlice = createSlice({
    name: 'carrierFeedback',
    initialState,
    reducers: {
        setQualificationPlan: (state, action) => {
            state.allQualificationPlan = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setAllCarrierFeedback: (state, action) => {
            state.allCarrierFeedback = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setOrganizationTree: (state, action) => {
            state.organizationTree = action.payload;
        },
        setAllQualificationMatrix: (state, action) => {
            state.allQualificationMatrix = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setAllSuccessStatistics: (state, action) => {
            state.allSuccessStatistics = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setDocuments: (state, action) => {
            state.documents = action.payload;
        },
    },

    extraReducers: (builder) => {
    },
});

export const { setAllCarrierFeedback, setOrganizationTree, setAllQualificationMatrix, setQualificationPlan, setAllSuccessStatistics, setDocuments } = carrierFeedbackSlice.actions;

export default carrierFeedbackSlice.reducer;